var acDonate = acDonate || {};

if (!Object.create) {
    Object.create = (function () {
        function F() {}

        return function (o) {
            if (arguments.length != 1) {
                throw new Error('Object.create implementation only accepts one parameter.');
            }
            F.prototype = o;
            return new F()
        }
    })()
}

jQuery(function ( $ ) {

    $.fn.donate = function( options ) {
        return this.each(function() {
            var donate = Object.create(acDonate.donate);
            donate.init(this, options);
        });
    };

    $.fn.donate.options = {
     };

    acDonate.donate = {

        init (elem, options) {
            var self = this;
            self.$container = $(elem);
            self.$input = self.$container.find(".donate-form__input-text");
            self.$hiddenInput = self.$container.find(".donate-form__level");
            self.$prefillInput = self.$container.find(".donate-form__prefill")
            self.$default = self.$input.val();
            self.$prefills = self.$container.find(".donate-form__prefills");
            self.$trigger = self.$container.find(".donate-form__quick-trigger");
            self.$dropdowns = self.$prefills.find(".donate-form__quick")
            self.$activeVal = self.$prefills.find(".donate-form__quick.active-val")
            self.$usdButton = self.$container.find(".donate-form__quick-label");
            self.$submit = self.$container.find(".donate-form__submit");

            self.$input.mask('#,##0.00',
                { reverse: true }
            );
            self.bindElements();
        },

        bindElements () {
            var self = this;

            self.$trigger.on("click", function() {
                self.$activeVal = $(this).parent();
                self.$input.parent().removeClass("has-error");
                self.$prefills.toggleClass("pre-show");
                self.$activeVal.addClass("active-val");
                self.$dropdowns.not( self.$activeVal ).removeClass("active-val");

                self.setValue( $(this).data("dollar") );
            });

            self.$input.on("focus", function() {
                if ( self.$activeVal = $(this).parent().parent() && !self.$prefills.hasClass("pre-show")) {
                    $(this).parent().removeClass( "has-error" );
                } else {
                    self.$activeVal = $(this).parent().parent();

                    self.$prefills.toggleClass("pre-show");
                    self.$activeVal.addClass("active-val");
                    self.$dropdowns.not( self.$activeVal ).removeClass("active-val");
                    self.setValue( $(this).data("dollar") );
                }
            });

            self.$input.bind("paste keydown", function(e) {
                self.$activeVal = $(this).parent().parent();
                self.$input.parent().removeClass("has-error");
            });

            self.$usdButton.on("click", function() {
                self.$activeVal = $(this).parent();

                self.$input.parent().removeClass("has-error");

                self.$prefills.toggleClass("pre-show");
                self.$activeVal.addClass("active-val");
                self.$dropdowns.not( self.$activeVal ).removeClass("active-val")
            });

            self.$container.on("submit", function() {
                 if( self.$activeVal.find(".donate-form__input-text").length ) {
                    return self.testValue();
                 }

                return true;
            });

        },
        testValue() {
            var self = this;
            var test = self.$input.val().replace(/,/, '');
            if(parseInt( test ) >= 5 ) {
                return true;
            } else {
                self.errorTriggered();
                return false;
            }
        },
        errorTriggered() {
            var self = this;
            self.$input.parent().addClass("has-error");
        },
        setValue (value) {
            var self = this;
            self.$hiddenInput.val( value ).trigger("change");
        }
    }
});
